export default __webpack_public_path__ + "static/media/latest-news-img32.fd48bae9.jpg";